module.exports = __webpack_public_path__ + "media/images/fbcalls/thumbnail_playlist-aa475d2a1164a43b1b80367dc46e3b6b.jpg";